import React, { useEffect, useState } from "react";

/**
 * Custom cursor — small glowing dot plus a delayed trailing ring.
 * Auto-disabled for touch devices via CSS media query.
 */
export default function CursorFollower() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [ringPos, setRingPos] = useState({ x: -100, y: -100 });
  const [scale, setScale] = useState(1);

  useEffect(() => {
    let target = { x: -100, y: -100 };
    let raf;

    const onMove = (e) => {
      target = { x: e.clientX, y: e.clientY };
      setPos(target);
    };

    const onOver = (e) => {
      const interactive = e.target.closest("a, button, [data-cursor-hover]");
      setScale(interactive ? 2 : 1);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);

    const tick = () => {
      setRingPos((prev) => ({
        x: prev.x + (target.x - prev.x) * 0.18,
        y: prev.y + (target.y - prev.y) * 0.18,
      }));
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div
        className="cursor-dot"
        style={{ left: `${pos.x}px`, top: `${pos.y}px` }}
      />
      <div
        className="cursor-ring"
        style={{
          left: `${ringPos.x}px`,
          top: `${ringPos.y}px`,
          transform: `translate(-50%, -50%) scale(${scale})`,
        }}
      />
    </>
  );
}
